import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import NavItemDesktopText from './NavItemDesktopText';
import NavItemDesktopImage from './NavItemDesktopImage';
import NavItemDesktopDynamicImage from './NavItemDesktopDynamicImage';
import NavItemDesktopPromotion from './NavItemDesktopPromotion';
import { generateTarget } from '../Common/Helpers/UrlHelper';
import { isCrawler } from '../Common/Helpers/GetOs';

const navItemTypes = {
  text: NavItemDesktopText,
  image: NavItemDesktopImage,
  dynamic_image: NavItemDesktopDynamicImage,
};

function renderMenuItem(menuItem, index, isPromotion, tRoute, height) {
  const NavItemType = isPromotion ? NavItemDesktopPromotion : (navItemTypes[menuItem.type] || NavItemDesktopText);

  return <NavItemType {...menuItem} key={index} tRoute={tRoute} height={height}/>;
}

function renderMenuItems(menuItems, isPromotion, tRoute) {
  let height;
  if (menuItems.length === 1) {
    height = '100%';
  }

  return menuItems.map((menuItem, index) => renderMenuItem(menuItem, index, isPromotion, tRoute, height));
}

function renderMenuBlock(menu, isPromotion, tRoute) {
  return menu.map((menuItems, index) =>
      <div className="mmd__column" key={index}>
        {renderMenuItems(menuItems, isPromotion, tRoute)}
      </div>
    );
}

function navItemClass(isPromotion) {
  const common = 'nav-link dropdown-toggle';
  const renderClass = isPromotion ? common + ' mmd--highlight' : common;
  return renderClass;
}

export default class NavItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isHovered: isCrawler(), // if it's a crawler, do render
    };
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true});
  };

  render() { 
    const {isHovered} = this.state;

    if (this.props.menuItems.length) {
      return (
        <li className="nav-item dropdown"
        onMouseEnter={this.handleMouseEnter}
        >
            <a
              className={navItemClass(this.props.isPromotion)}
              href={this.props.tRoute(this.props.href)}
              data-toggle="dropdown"
              target={generateTarget(this.props.href)}
              id={this.props.isPromotion ? 'promotionNavbarLink' : (this.props.label == 'Photobooks' ? 'photobookNavbarLink' : null) }
            >
              {this.props.label}
            </a>
            <div className="dropdown-menu">
              {renderMenuBlock(!isHovered ? [] : this.props.menuItems, this.props.isPromotion, this.props.tRoute)}
            </div>
        </li>
      );

    }
    return (
      <li className="nav-item dropdown">
        <a
          className={navItemClass(this.props.isPromotion)}
          href={this.props.tRoute(this.props.href)}
          id={this.props.isPromotion ? 'promotionNavbarLink' : (this.props.label == 'Photobooks' ? 'photobookNavbarLink' : null) }
        >
          {this.props.label}
        </a>
      </li>
    );
  }
}

NavItem.propTypes = {
  label: PropTypes.string,
  href: PropTypes.string,
  menuItems: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/Nav/NavItem.js